import React from 'react'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { css } from '@emotion/core'
import theme from '../../../config/theme'
import { rhythm } from '../../lib/typography'
import { bpMaxSM } from '../../lib/breakpoints'
import Message from '../ConfirmMessage/Message'
import { PleaseConfirmIllustration } from '../ConfirmMessage/Illustrations'
import Airtable from 'airtable';

const AIRTABLE_API_KEY = process.env.AIRTABLE_API_KEY

Airtable.configure({
    endpointUrl: 'https://api.airtable.com',
    apiKey: AIRTABLE_API_KEY
});

var base = Airtable.base('app9n9uWrtaJ4GeZV');

const SubscribeSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Required'),
  name: Yup.string(),
})

const PostSubmissionMessage = ({ response }) => {
  return (
    <div>
      <Message
        illustration={PleaseConfirmIllustration}
        title={`Perfect!`}
        body={`You're subscribed for more great content.`}
      />
    </div>
  )
}

class AirtableSignUp extends React.Component {
  state = {
    submitted: false,
  }

  async handleSubmit(values, actions) {
    this.setState({ submitted: false })

    try {
        const existing = await base('Subscriptions').select({
            filterByFormula: `email='${values.email}'`
        }).firstPage()

        if (existing.length === 0) {
            const response = await base('Subscriptions').create(values);

            const fields = response.fields;

            this.setState({
                submitted: true,
                response: fields,
                errorMessage: null,
            })
            actions.setSubmitting(false);
            actions.resetForm();
        } else {
            this.setState({
                submitted: false,
                errorMessage: "You're already subscribed."
            })
            actions.setSubmitting(false);
        }

    } catch (error) {
      this.setState({
        submitted: false,
        errorMessage: 'Something went wrong!',
      })
    }
  }

  render() {
    const { submitted, response, errorMessage } = this.state
    const successful = response && response.status === 'success'

    return (
      <div>
        {!successful && (
          <h2
            css={css`
              margin-bottom: ${rhythm(1)}
              margin-top: 0
            `}
          >
            Join the Newsletter
          </h2>
        )}

        <Formik
          initialValues={{
            email: '',
            name: '',
          }}
          validationSchema={SubscribeSchema}
          onSubmit={(values, actions) => this.handleSubmit(values, actions)}
          render={({ errors, touched, isSubmitting }) => (
            <>
              {!successful && (
                <Form
                  css={css`
                    display: flex
                    align-items: flex-end
                    label:not(:first-of-type),
                    button {
                      margin-left: 10px
                    }
                    .field-error {
                      display: block
                      //position: absolute
                      color: ${theme.colors.red}
                      font-size: 80%
                    }
                    input,
                    label {
                      width: 100%
                    }
                    ${bpMaxSM} {
                      flex-direction: column
                      align-items: flex-start
                      width: auto
                      label,
                      input {
                        margin: 5px 0 0 0 !important
                        width: 100%
                        display: flex
                        flex-direction: column
                      }
                      button {
                        margin: 20px 0 0 0
                      }
                    }
                  `}
                >
                  <label htmlFor="name">
                    <div
                      css={css`
                        display: flex
                        justify-content: space-between
                        align-items: flex-end
                      `}
                    >
                      First Name
                      <ErrorMessage
                        name="name"
                        component="span"
                        className="field-error"
                      />
                    </div>
                    <Field
                      aria-label="your first name"
                      aria-required="false"
                      name="name"
                      placeholder="Jane"
                      type="text"
                    />
                  </label>
                  <label htmlFor="email">
                    <div
                      css={css`
                        display: flex
                        justify-content: space-between
                        align-items: flex-end
                      `}
                    >
                      Email
                      <ErrorMessage
                        name="email"
                        component="span"
                        className="field-error"
                      />
                    </div>
                    <Field
                      aria-label="your email address"
                      aria-required="true"
                      name="email"
                      placeholder="jane@acme.com"
                      type="email"
                    />
                  </label>
                  <button
                    data-element="submit"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {!isSubmitting && 'Submit'}
                    {isSubmitting && 'Submitting...'}
                  </button>
                </Form>
              )}
              {submitted && !isSubmitting && (
                <PostSubmissionMessage response={response} />
              )}
              {errorMessage && <div>{errorMessage}</div>}
            </>
          )}
        />
      </div>
    )
  }
}

export default AirtableSignUp